// There is a global variable created by the Java backend containing all the environment parameters.
export const env = (window as any).env;

export const environment = {
  devTools: false,

  production: false,

  ASH_URL: 'https://uat.servicehub.amadeus.com/',
};
